import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Projects from "./scenes/projects";
import Clients from "./scenes/clients";
import Services from "./scenes/services";
import Invoices from "./scenes/invoices";
import InvoiceItems from "./scenes/invoiceitems";
import Payments from "./scenes/payments";
import PaymentsByStatus from "./scenes/payments/indexByStatus";
import PaymentsByCurrency from "./scenes/payments/indexByCurrency";
import PaymentsByBillingCycle from "./scenes/payments/indexByBillingCycle";
import PaymentsByRefundStatus from "./scenes/payments/indexByRefundStatus";
import Estimates from "./scenes/estimates";
import SubscriptionBilling from "./scenes/subscriptionbilling";
import SubscriptionBillingByStatus from "./scenes/subscriptionbilling/indexByStatus";
import SubscriptionBillingByFrequency from "./scenes/subscriptionbilling/indexByFrequency";
import PaymentReminders from "./scenes/paymentreminders";
import RecurringBilling from "./scenes/recurringbilling";
import RecurringBillingByStatus from "./scenes/recurringbilling/indexByStatus";
import RecurringBillingByFrequency from "./scenes/recurringbilling/indexByFrequency";
import Expenses from "./scenes/expenses";
import ExpensesByStatus from "./scenes/expenses/indexByStatus";
import ExpensesByApprovalStatus from "./scenes/expenses/indexByApprovalStatus";
import ExpensesByPaymentMethod from "./scenes/expenses/indexByPaymentMethod";
import ExpensesByReimbursementStatus from "./scenes/expenses/indexByReimbursementStatus";
import ExpensesByCurrency from "./scenes/expenses/indexByCurrency";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/projects" element={<ProtectedRoute element={<Projects searchTerm={searchTerm} />} />} />
<Route path="/clients" element={<ProtectedRoute element={<Clients searchTerm={searchTerm} />} />} />
<Route path="/services" element={<ProtectedRoute element={<Services searchTerm={searchTerm} />} />} />
<Route path="/invoices" element={<ProtectedRoute element={<Invoices searchTerm={searchTerm} />} />} />
<Route path="/invoiceitems" element={<ProtectedRoute element={<InvoiceItems searchTerm={searchTerm} />} />} />
<Route path="/payments" element={<ProtectedRoute element={<Payments searchTerm={searchTerm} />} />} />
<Route path="/payments/list" element={<ProtectedRoute element={<Payments searchTerm={searchTerm} />} />} />
<Route path="/payments/status" element={<ProtectedRoute element={<PaymentsByStatus searchTerm={searchTerm} />} />} />
<Route path="/payments/currency" element={<ProtectedRoute element={<PaymentsByCurrency searchTerm={searchTerm} />} />} />
<Route path="/payments/billingcycle" element={<ProtectedRoute element={<PaymentsByBillingCycle searchTerm={searchTerm} />} />} />
<Route path="/payments/refundstatus" element={<ProtectedRoute element={<PaymentsByRefundStatus searchTerm={searchTerm} />} />} />
<Route path="/estimates" element={<ProtectedRoute element={<Estimates searchTerm={searchTerm} />} />} />
<Route path="/estimates/list" element={<ProtectedRoute element={<Estimates searchTerm={searchTerm} />} />} />
<Route path="/subscriptionbilling" element={<ProtectedRoute element={<SubscriptionBilling searchTerm={searchTerm} />} />} />
<Route path="/subscriptionbilling/list" element={<ProtectedRoute element={<SubscriptionBilling searchTerm={searchTerm} />} />} />
<Route path="/subscriptionbilling/status" element={<ProtectedRoute element={<SubscriptionBillingByStatus searchTerm={searchTerm} />} />} />
<Route path="/subscriptionbilling/frequency" element={<ProtectedRoute element={<SubscriptionBillingByFrequency searchTerm={searchTerm} />} />} />
<Route path="/paymentreminders" element={<ProtectedRoute element={<PaymentReminders searchTerm={searchTerm} />} />} />
<Route path="/paymentreminders/list" element={<ProtectedRoute element={<PaymentReminders searchTerm={searchTerm} />} />} />
<Route path="/recurringbilling" element={<ProtectedRoute element={<RecurringBilling searchTerm={searchTerm} />} />} />
<Route path="/recurringbilling/list" element={<ProtectedRoute element={<RecurringBilling searchTerm={searchTerm} />} />} />
<Route path="/recurringbilling/status" element={<ProtectedRoute element={<RecurringBillingByStatus searchTerm={searchTerm} />} />} />
<Route path="/recurringbilling/frequency" element={<ProtectedRoute element={<RecurringBillingByFrequency searchTerm={searchTerm} />} />} />
<Route path="/expenses" element={<ProtectedRoute element={<Expenses searchTerm={searchTerm} />} />} />
<Route path="/expenses/list" element={<ProtectedRoute element={<Expenses searchTerm={searchTerm} />} />} />
<Route path="/expenses/status" element={<ProtectedRoute element={<ExpensesByStatus searchTerm={searchTerm} />} />} />
<Route path="/expenses/approvalstatus" element={<ProtectedRoute element={<ExpensesByApprovalStatus searchTerm={searchTerm} />} />} />
<Route path="/expenses/paymentmethod" element={<ProtectedRoute element={<ExpensesByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/expenses/reimbursementstatus" element={<ProtectedRoute element={<ExpensesByReimbursementStatus searchTerm={searchTerm} />} />} />
<Route path="/expenses/currency" element={<ProtectedRoute element={<ExpensesByCurrency searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
